import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { API_URL, IPlanGracePeriodDto } from '@/dtos';

const QUERY_KEY = 'useGetPlanTerminationDataQueryKey';

const planFormatter = (data: IPlanGracePeriodDto) => {
  return {
    id: `${data.id}`,
    name: data.name,
    startDate: data?.start_date ? dayjs(data.start_date).format(DEFAULT_DATE_FORMAT) : undefined,
    endDate: data?.end_date ? dayjs(data.end_date).format(DEFAULT_DATE_FORMAT) : undefined,
    claimLastDate: data?.claim_last_date
      ? dayjs(data.claim_last_date).format(DEFAULT_DATE_FORMAT)
      : undefined,
    coverageEndDate: data?.coverage_end_date
      ? dayjs(data.coverage_end_date).format(DEFAULT_DATE_FORMAT)
      : undefined,
  };
};


export interface PlanTermination {
  id: string;
  name: string;
  startDate: string;
  endDate?: string;
  claimLastDate?: string;
  coverageEndDate?: string;
}

export const useGetPlanCoverageTerminationDataQuery = (planId?: string, terminationDate?: string) => {
  const { isLoading, isSuccess, data, refetch } = useQuery(
    [planId, terminationDate, QUERY_KEY],
    planId && terminationDate
      ? () =>
          api.get(API_URL.PLANS_ACTIVE_GRACE_PERIOD_BY_PLAN_ID(planId), {
            params: { termination_date: terminationDate },
          })
      : () => null
  );

  const formattedData = useMemo(() => {
    if (!data?.data) return null;
    return planFormatter(data.data);
  }, [data]);

  return {
    data: data?.data,
    formattedData,
    isLoading,
    isSuccess,
    refetch,
  };
};
